import Axios from 'axios';

const recaptchaToken = async ({ googleRecaptchaAction, googleRecaptchaClientSide }) => new Promise((resolve, reject) => {
  window.grecaptcha.ready(() => {
    window.grecaptcha.execute(googleRecaptchaClientSide, { action: googleRecaptchaAction }).then((token) => {
      resolve(token);
    });
  });
});

const axios = Axios.create({
  transformRequest: [function (data, headers) {
    if (data && Object.entries(data)) {
      const formData = new FormData();
      for (const [key, value] of Object.entries(data)) {
        formData.append(key, value);
      }
      return formData;
    }
  }],
});

// Add a request interceptor
axios.interceptors.request.use(async (config) => {
  // Do something before request is sent
  if (config.data && config.data.googleRecaptchaAction && config.data.googleRecaptchaClientSide) {
    const token = await recaptchaToken(config.data);
    config.data.googleRecaptchaToken = token;
    return config;
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

export const { CancelToken } = Axios;

export const {
  get, post, all, spread
} = axios;
